import type { FilesToUpload } from '@/types/Shared';

export const criticalRepairDocumentFields = [
  'proofOfOwnership',
  'proofOfOccupancy',
  'zeroIncomeAffidavit',
  'bankStatements',
  'proofOfIncome',
] as const;

export type CriticalRepairDocumentField = (typeof criticalRepairDocumentFields)[number];

export type CriticalRepairDocuments = Partial<Record<CriticalRepairDocumentField, unknown[]>>;

const requiredMetadataFields = ['name', 'key', 'path', 'type', 'field'] as const;
const requiredDocumentFields: CriticalRepairDocumentField[] = ['proofOfOwnership', 'proofOfOccupancy', 'bankStatements'];

export function isApplicationFileMetadata(value: unknown): value is FilesToUpload {
  if (!value || typeof value !== 'object') return false;

  const candidate = value as Record<string, unknown>;
  return requiredMetadataFields.every((field) => typeof candidate[field] === 'string' && candidate[field].trim().length > 0);
}

export function hasOnlyApplicationFileMetadata(value: unknown): value is FilesToUpload[] {
  return Array.isArray(value) && value.every(isApplicationFileMetadata);
}

export function collectCriticalRepairSubmissionFiles(documents: CriticalRepairDocuments | undefined): FilesToUpload[] | null {
  const files: FilesToUpload[] = [];

  for (const field of criticalRepairDocumentFields) {
    const entries = documents?.[field] ?? [];
    if (requiredDocumentFields.includes(field) && entries.length === 0) return null;
    if (!hasOnlyApplicationFileMetadata(entries)) return null;
    files.push(...entries);
  }

  return files;
}
